
/* eslint-disable no-unused-vars */
import request from '../../request'

export default {
  /**
   * 获取 全平台利润明细列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchAllPlatformProfitDetailsByPage(data = {}, options = {}) {
    return request(
      {
        url: '/allplatform/queryProfitDetailsByPage',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 获取 全平台利润明细列表总计
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchAllPlatformProfitDetailsByPageTotal(data = {}, options = {}) {
    return request(
      {
        url: '/allplatform/queryTotalData',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 查询利润报告 列表
   */
  async fetchAllPlatformProfitReportList(data = {}, options = {}) {
    return request(
      {
        url: '/allplatform/queryProfitResport',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 支出结构 chart data
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchChartDataExpenseStructure(data = {}, options = {}) {
    return request(
      {
        url: '/allplatform/ringDiagramOfCostAnalysis',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * chartdata 支出项明细
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchChartDataExpensItemDetail(data = {}, options = {}) {
    return request(
      {
        url: '/allplatform/expensItemDetail',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * chartdata 渠道利润top10
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchChartDataChannelProfitTopTen(data = {}, options = {}) {
    return request(
      {
        url: '/allplatform/channelAnalysis',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * chartdata 渠道拆解
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchChartDataChannelResolve(data = {}, options = {}) {
    return request(
      {
        url: '/allplatform/channelDismantling',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 获取指标卡片 1=总览 2=收入  3=支出
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchChartDataStatistics(data = {}, options = {}) {
    return request(
      {
        url: '/allplatform/indicatorOverview',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 获取指标卡 的数据列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchChartDataStatisticsDataList(data = {}, options = {}) {
    return request(
      {
        url: '/allplatform/histogramAnalysis',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 获取图标数据 经营结构
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchChartDataOperationStructure(data = {}, options = {}) {
    return request(
      {
        url: '/allplatform/quadrantAnalysis',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
  /**
   * 渠道拆解解读信息
   * @param {*} data
   * @param {*} options
   * @returns
   *  overallProfit 整体利润
   *  platformName 平台名
   *  proportionOfoverallProfit 占比
   *  shopNameOfHighProfit 指定平台下高利润店铺名称
   *  proportionOfHighProfitShopName 利润占比
   *  quadrant 结构体系
   *  currencySymbol 货币符号
   */
  async fetchChartDataChannelResolveDesc(data = {}, options = {}) {
    return request(
      {
        url: '/allplatform/dataAnalysis',
        method: 'post',
        desc: '',
      },
      {
        ...data,
      },
      options
    )
  },
}
